"use strict";
/**
 * @author: yangqianjun
 * @file: ajax统一封装
 * @Date: 2019-11-21 15:26:02
 * @LastEditors: yangqianjun
 * @LastEditTime: 2019-12-18 21:13:15
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var new_ajax_1 = tslib_1.__importDefault(require("./new-ajax"));
tslib_1.__exportStar(require("./axios"), exports);
tslib_1.__exportStar(require("./new-ajax"), exports);
tslib_1.__exportStar(require("./graphql"), exports);
tslib_1.__exportStar(require("./useFetch"), exports);
exports.default = new_ajax_1.default;
var consts_1 = require("./consts");
exports.AjaxCancelCode = consts_1.AjaxCancelCode;
exports.AjaxErrorCode = consts_1.AjaxErrorCode;
exports.GraphQLErrorCode = consts_1.GraphQLErrorCode;
//# sourceMappingURL=index.js.map